import React, { Component } from 'react';
import { isValidDate } from '@/utils/helpers';

class PrintSurgeryCommitment extends Component {

    render() {
        const { customer } = this.props;

        return (
            <div>
                <div className="print-container">
                    <div className='page-break'>
                        {/* Header */}
                        <div className="header">
                            <div className="header-left">
                                Công ty TNHH Anh Nguyễn Beauty
                                <br />
                                Cơ sở KB, CB: Nha khoa CHINGO
                            </div>
                            <div className="header-center">
                                <div className="header-title">
                                    CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
                                    <br />
                                    <span className="subtitle">Độc lập - Tự do - Hạnh phúc</span>
                                </div>
                            </div>
                            <div className="header-right">MS: 01/BV2</div>
                        </div>
                        <h2 className="form-title">
                            GIẤY CAM KẾT CHẤP THUẬN
                            <br />
                            PHẪU THUẬT, THỦ THUẬT VÀ GÂY MÊ HỒI SỨC
                        </h2>
                        <div className="form-subtitle">
                            <label>
                                <input type="checkbox" /> Cấp cứu
                            </label>
                            <label>
                                <input type="checkbox" /> Bán cấp
                            </label>
                            <label>
                                <input type="checkbox" /> Chương trình/Phiên
                            </label>
                        </div>
                        <p style={{ margin: 0 }}>Chúng tôi có tên dưới đây cùng làm Bản cam kết như sau:</p>
                        {/* I. Bác sĩ */}
                        <h3 style={{ margin: 0 }}>I. BÁC SỸ PHẪU THUẬT/THỦ THUẬT/GÂY MÊ HỒI SỨC:</h3>
                        <p>
                            Tôi tên là: ..................................................................................................................................................
                            <br />
                            Chức danh: .......................................
                            Khoa: .......................................................................................
                            <br />
                            và Bác sỹ: ......................................................
                            Chức danh: ....................  (Khoa phẫu thuật Gây mê hồi sức)
                            <br />
                            Được phân công thực hiện phẫu thuật/thủ thuật/gây mê cho người bệnh: ...............................................
                            <br />
                            Chẩn đoán:................................................................................................................................................
                        </p>
                        <p>
                            Chúng tôi đã tư vấn, giải thích đầy đủ, rõ ràng những thông tin liên quan đến cuộc phẫu thuật/thủ thuật/gây mê hồi sức cho người bệnh/thân nhân người bệnh về các vấn đề sau:
                        </p>
                        <ul className="checklist">
                            <li>
                                <input type="checkbox" /> Chẩn đoán
                            </li>
                            <li>
                                <input type="checkbox" /> Lý do phẫu thuật/thủ thuật
                            </li>
                            <li>
                                <input type="checkbox" /> Rủi ro, nguy cơ nếu không thực hiện phẫu thuật/thủ thuật
                            </li>
                            <li>
                                <input type="checkbox" /> Kết quả sau phẫu thuật/thủ thuật (Dự kiến)......................................................................................
                            </li>
                        </ul>
                        <p>
                            <b>Phương pháp phẫu thuật/thủ thuật dự kiến</b>
                        </p>
                        <div className="checkbox-group">
                            <label className='w-150'>
                                <input type="checkbox" /> Phẫu thuật mở
                            </label>
                            <label className='w-200'>
                                <input type="checkbox" /> Phẫu thuật nội soi
                            </label>
                            <label>
                                <input type="checkbox" /> Thủ thuật
                            </label>
                        </div>
                        <p>
                            <b>Phương pháp gây mê hồi sức dự kiến:</b>
                        </p>
                        <div className="checkbox-group">
                            <label className='w-150'>
                                <input type="checkbox" /> Mê nội khí quản
                            </label>
                            <label className='w-200'>
                                <input type="checkbox" /> Mê mask thanh quản
                            </label>
                            <label className='w-150'>
                                <input type="checkbox" /> Mê tĩnh mạch
                            </label>
                            <label>
                                <input type="checkbox" /> Tê tủy sống
                            </label>
                        </div>
                        <div className="checkbox-group">
                            <label className='w-150'>
                                <input type="checkbox" /> Tê ngoài màng cứng
                            </label>
                            <label className='w-200'>
                                <input type="checkbox" /> Tê đám rối thần kinh
                            </label>
                            <label className='w-150'>
                                <input type="checkbox" /> Tiền mê + Tê tại chỗ
                            </label>
                            <label>
                                <input type="checkbox" /> Khác
                            </label>
                        </div>
                        <p>
                            <b>Các phương pháp điều trị khác ngoài phẫu thuật/thủ thuật:</b>
                        </p>
                        <div className="checkbox-group">
                            <label className='w-150'>
                                <input type="checkbox" /> Không
                            </label>
                            <label>
                                <input type="checkbox" /> Có, cụ thể: ......................................................................................
                            </label>
                        </div>
                        <p>
                            <b>Nguy cơ, tai biến trong và sau phẫu thuật/thủ thuật có thể xảy ra:</b>
                        </p>
                        <div className="checkbox-group">
                            <label className='w-150'>
                                <input type="checkbox" /> Phản ứng thuốc
                            </label>
                            <label className='w-200'>
                                <input type="checkbox" /> Suy hô hấp - tuần hoàn
                            </label>
                            <label>
                                <input type="checkbox" /> Chảy máu
                            </label>
                        </div>
                        <div className="checkbox-group">
                            <label className='w-150'>
                                <input type="checkbox" /> Nhiễm trùng
                            </label>
                            <label className='w-200'>
                                <input type="checkbox" /> Tử vong
                            </label>
                            <label>
                                <input type="checkbox" /> Nguy cơ/rủi ro khác: ........................
                            </label>
                        </div>
                        <p className='text-indent'>
                            Chúng tôi đã dành đủ thời gian để người bệnh/thân nhân đặt các câu hỏi liên
                            quan đến phẫu thuật/thủ thuật/gây mê sẽ được thực hiện hoặc các mối quan tâm khác và
                            chúng tôi đã trả lời tất cả các câu hỏi đó.
                        </p>
                        <p className='text-indent'>
                            Chúng tôi cam kết phục vụ người bệnh bằng lương tâm và trách nhiệm của người thầy thuốc cùng với tất cả kiến thức,
                            sự hiểu biết về chuyên môn và phương tiện hiện có của
                            (Tên cơ sở khám bệnh, chữa bệnh) .............................................................................................
                            để nỗ lực đem lại kết quả tốt nhất cho người bệnh.
                        </p>
                    </div>
                    <div className='page-break'>
                        {/* II. Người bệnh */}
                        <h3 style={{ margin: 0 }}>II. NGƯỜI BỆNH/THÂN NHÂN: </h3>
                        <p>
                            Họ và tên người bệnh: {customer?.full_name ? <b>{customer.full_name}</b> : '..................................................................'}&nbsp;&nbsp;
                            Năm sinh: {customer?.birthday ? isValidDate(customer?.birthday, false) : '.................................'}
                            <br />
                            Họ và tên thân nhân: ................................................................
                            Năm sinh: .................................
                            <br />
                            Quan hệ với người bệnh:
                            .........................................................................................................
                        </p>
                        <p className='text-indent'>
                            Tôi đã được nghe các Bác sỹ giải thích và đã trao đổi với các Bác sỹ về tất cả các thông tin
                            của cuộc phẫu thuật/thủ thuật/gây mê, những nguy cơ thường gặp có thể xảy ra trong
                            phẫu thuật/thủ thuật/gây mê như:............................................................................................................................................................
                        </p>
                        <p>.....................................................................................................................................................................</p>
                        <p>
                            và mức độ thành công. Tôi đã hiểu lý do phải thực hiện phẫu thuật/thủ thuật/gây mê và đồng ý để Bác sỹ phẫu thuật/thủ thuật/gây mê cho tôi/thân nhân của tôi.
                        </p>
                        <p className='text-indent'>
                            Tôi đã được tư vấn những thông tin về chi phí phẫu thuật/thủ thuật/gây mê, vật tư y tế tiêu hao dự kiến sử dụng trong cuộc phẫu thuật/thủ thuật/gây mê, tôi cam kết chi trả chi phí khám bệnh, chữa bệnh ngoài phạm vi được hưởng và mức hưởng theo quy định của pháp luật về bảo hiểm y tế và các quy định khác.
                        </p>
                        <p className='text-indent'>
                            Tôi đồng ý để các Bác sỹ thực hiện các phẫu thuật/thủ thuật/gây mê/kiểm tra/điều trị nếu việc đó là cần thiết để cứu tính mạng hoặc ngăn ngừa tác hại nghiêm trọng cho sức khỏe của tôi/thân nhân của tôi.
                        </p>
                        <p className='text-indent'>
                            Tôi hiểu rằng các Bác sỹ của (tên cơ sở khám bệnh, chữa bệnh )........................................... sẽ làm hết lương tâm, trách nhiệm cùng với tất cả kiến thức, sự hiểu biết và phương tiện hiện có để nỗ lực đem lại kết quả tốt nhất cho tôi/thân nhân của tôi. Tuy nhiên, cũng không thể đảm bảo hoàn toàn với tôi rằng phẫu thuật/thủ thuật sẽ cải thiện tình trạng hoặc không làm cho tình trạng của tôi/ thân nhân của tôi trở nên xấu đi.
                        </p>
                        <p className='text-indent'>
                            Tôi đã đọc bản cam kết với tinh thần hoàn toàn minh mẫn và hiểu biết. Tôi đã hiểu các vấn đề mà Bác sỹ đã giải thích về tiến trình phẫu thuật/thủ thuật/gây mê cho tôi/thân nhân của tôi. Tôi xin hoàn toàn chịu trách nhiệm với quyết định đồng ý cho Bác sỹ phẫu thuật/thủ thuật cho tôi/thân nhân của tôi.
                        </p>
                        <p className='text-indent'>
                            Sau khi nghe các Bác sỹ cho biết tình trạng bệnh của tôi/thân nhân của tôi, những nguy hiểm của bệnh nếu không thực hiện phẫu thuật/thủ thuật/gây mê hồi sức và những rủi ro có thể xảy ra do bệnh tật, do khi tiến hành phẫu thuật/thủ thuật/gây mê hồi sức; tôi tự nguyện viết giấy cam đoan này:
                        </p>
                        <p>
                            1. Đồng ý xin phẫu thuật, thủ thuật, gây mê hồi sức và để giấy này làm bằng chứng.
                        </p>
                        <p>
                            2. Không đồng ý phẫu thuật, thủ thuật, gây mê hồi sức và để giấy này làm bằng chứng.
                        </p>
                        <p>
                            (Câu 1 và câu 2 do người bệnh, thân nhân của người bệnh tự viết dưới đây).<br />
                        </p>
                        <p>....................................................................................................................................................................</p>
                        <p className="signature-block">
                            <span>
                                <b>
                                    PHẪU THUẬT VIÊN/
                                    <br />
                                    BÁC SỸ THỰC HIỆN THỦ THUẬT
                                </b>
                                <br />
                                (Ký, ghi rõ họ tên)
                            </span>
                            <span>
                                <b>BÁC SỸ GÂY MÊ</b>
                                <br />
                                (Ký, ghi rõ họ tên)
                            </span>
                            <span>
                                {/* Ngày {formatVietnameseDate(moment().format('DD/MM/YYYY'))} */}
                                Ngày ........ tháng ........ năm ........
                                <br />
                                <b>NGƯỜI BỆNH/THÂN NHÂN</b>
                                <br />
                                (Ký, ghi rõ họ tên)
                            </span>
                        </p>
                    </div>
                </div>

                <style>
                    {`
                        @page {
                            size: A4;
                            margin: 1cm 1.2cm 1cm 1.8cm;
                            /* top, right, bottom, left */
                        }

                        :root {
                            --text: #111;
                            --muted: #666;
                            --border: #ddd;
                            --heading: #000;
                            --primary: #0b2b33;
                        }

                        @media print {
                            .no-print {
                                display: none !important;
                            }

                            .page-break {
                                page-break-before: always;
                            }

                            html,
                            body {
                                margin: 0 auto;
                                padding: 0;
                            }
                        }
                        .print-container {
                            width: 100%;
                            font-family: "Times New Roman", serif;
                            font-size: 12pt;
                            line-height: 1.5;
                            color: #000;
                            page-break-after: always;
                            word-wrap: break-word;
                        }

                        /* ===== HEADER ===== */
                        .print-container .header {
                            display: grid;
                            grid-template-columns: 0.8fr 2fr 0.8fr;
                            /* cột giữa rộng hơn */
                            align-items: start;
                            column-gap: 4mm;
                            margin-bottom: 6mm;
                        }

                        .print-container .header-left {
                            font-size: 11pt;
                            line-height: 1.4;
                        }

                        .print-container .header-center {
                            text-align: center;
                        }

                        .print-container .header-title {
                            font-weight: bold;
                            font-size: 13pt;
                            line-height: 1.35;
                        }

                        .print-container .header-title .subtitle {
                            font-weight: normal;
                            font-size: 12pt;
                        }

                        .print-container .header-right {
                            text-align: right;
                            font-weight: bold;
                            font-size: 11pt;
                        }

                        /* ===== TITLE ===== */
                        .print-container .form-title {
                            text-align: center;
                            text-transform: uppercase;
                            font-size: 13pt;
                            font-weight: bold;
                            margin: 0;
                            line-height: 1.5;
                        }

                        .print-container .form-subtitle {
                            text-align: center;
                            margin-bottom: 5mm;
                        }

                        .print-container .form-subtitle label {
                            margin: 0 5mm;
                        }

                        /* ===== CONTENT ===== */
                        .print-container p {
                            margin: 1mm 0;
                            text-align: left;
                        }

                        .print-container ul.checklist {
                            list-style: none;
                            padding-left: 0;
                            margin: 2mm 0;
                        }

                        .print-container ul.checklist li {
                            margin-bottom: 2mm;
                        }

                        .print-container .checkbox-group {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 6mm;
                            margin-bottom: 3mm;
                        }

                        .print-container input[type="checkbox"] {
                            width: 18px;
                            height: 18px;
                            margin: 0;
                            position: relative;
                            bottom: -2px;
                        }

                        .print-container .checkbox-group label {
                            white-space: nowrap;
                        }

                        /* ===== SIGNATURE BLOCK ===== */
                        .print-container .signature-block {
                            display: grid;
                            grid-template-columns: 1fr 1fr 1fr;
                            text-align: center;
                            margin-top: 10mm;
                            font-size: 12pt;
                        }

                        .print-container .signature-block span {
                            display: inline-block;
                            line-height: 1.6;
                        }

                        .print-container .line {
                            height: 5mm;
                            border-bottom: 0.3pt dotted #000;
                            margin: 0.8mm 0;
                        }

                        .w-150{
                            width: 150px;
                        }

                        .w-200{
                            width: 200px;
                        }

                        .text-indent{
                            text-indent: 20px;
                        }
                    `}
                </style>
            </div >
        );
    }
}

export default PrintSurgeryCommitment;
